import ResetPasswordForm from '@/components/forms/auth/ResetPasswordForm'
import { Meta } from '@cfs-fixings/shared'

function ResetPasswordPage () {
  return <>
    <Meta title="Reset Password" />

    <div className="flex justify-center w-full mt-[110px]">
      <ResetPasswordForm />
    </div>
  </>
}

export default ResetPasswordPage
